import * as React from 'react';
import { Main } from '../layouts/main';
import { About } from '../components/about';

export default function KancelariaPage(): React.ReactNode {
  return (
    <Main title="Advocare - Kancelaria">
      <About />
    </Main>
  );
}
